const KEY_PREFIX = "artis_live_call_";

/**
 * Lets a live call survive a full page navigation/reload — not just the
 * client-side routing a single-page app can give for free. The server
 * already resumes a dropped connection by conversation_id (same mechanism
 * used for a network blip mid-call — see ai-service's on_connect /
 * RESUMABLE_LIVE_STATUSES); this is what lets the widget reuse that path
 * for "the page reloaded" too, instead of always minting a brand new
 * conversation on every page load.
 *
 * sessionStorage, not localStorage, is deliberate: it survives a reload or
 * a same-tab navigation, but starts clean in a new tab or once the tab is
 * closed — we never want to resume into a tab/session that never had this
 * call running.
 */

export function saveLiveCall(agentId: string, conversationId: string): void {
  try {
    sessionStorage.setItem(KEY_PREFIX + agentId, conversationId);
  } catch {
    // Private browsing / blocked storage — resume-on-reload just won't
    // work for this visitor; starting a fresh call still does.
  }
}

export function getLiveCall(agentId: string): string | null {
  try {
    return sessionStorage.getItem(KEY_PREFIX + agentId);
  } catch {
    return null;
  }
}

export function clearLiveCall(agentId: string): void {
  try {
    sessionStorage.removeItem(KEY_PREFIX + agentId);
  } catch {
    // Nothing to clean up if storage isn't available in the first place.
  }
}
